export const SECTION_DEFS = [
  {
    page: "Home Page",
    items: [
      { key: "home_marquee", label: "Treatment marquee ribbon" },
      { key: "home_treatments", label: "Signature treatments grid" },
      { key: "home_doctors", label: "Doctor spotlight" },
      { key: "home_gallery", label: "Results teaser strip" },
      { key: "home_testimonials", label: "Testimonials carousel" },
      { key: "home_instagram", label: "Instagram feed" },
      { key: "home_cta", label: "Final booking banner" },
    ],
  },
  {
    page: "Treatments Page",
    items: [{ key: "treatments_packages", label: "VIP membership packages" }],
  },
  {
    page: "Gallery Page",
    items: [
      { key: "gallery_before_after", label: "Before & after sliders" },
      { key: "gallery_photos", label: "Clinic photo grid" },
    ],
  },
  {
    page: "Journal",
    items: [{ key: "article_cta", label: "Article booking banner" }],
  },
  {
    page: "Contact Page",
    items: [{ key: "contact_map", label: "Location map" }],
  },
];
